// intro-section.component.ts
import { Component, Input, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: "app-intro-section",
  templateUrl: "./intro.component.html",
  styleUrls: ["./intro.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class IntroSectionComponent {
  @Input() sectionClass: string = "";
}
